import PowerExample from "./containers/powerExample";
export default PowerExample;